import './Footer.scss';
import linkedInIcon from '../../img/Icons/linkedInIconWhite2.webp';
import instagramIcon from '../../img/Icons/instagramIconWhite2.webp';
import cakeryIcon from '../../img/Icons/cakeryIcon2.webp';

export default function Navigation() {
  return (
    <footer className="footer">
      <p className="copywrite-text">© {(new Date().getFullYear())} made by Victoria. All rights reserved.</p>
      <div className="social-links">
        <a href="https://www.instagram.com/victoriamineva/" className="social-link" target='_blank' rel="noreferrer" aria-label="Link to my Instagram profile">
          <img src={instagramIcon} className="social-icon" alt="Instagram icon" height="100%" width="100%" aria-hidden="true" />
          <span className="social-link-text">Instagram</span>
        </a>
        <a href="https://www.linkedin.com/in/victoria-mineva-797525a3" className="social-link" target='_blank' rel="noreferrer" aria-label="Link to my LinkedIn profile">
          <img src={linkedInIcon} className="social-icon" alt="LinkedIn icon" height="100%" width="100%" aria-hidden="true" />
          <span className="social-link-text">LinkedIn</span>
        </a>
        <a href="https://www.cakery.victoriamineva.com" className="social-link" target='_blank' rel="noreferrer" aria-label="Link to my baking website">
          <img src={cakeryIcon} className="social-icon" alt="Viky's Cakery icon" height="100%" width="100%" aria-hidden="true" />
          <span className="social-link-text">Viky's Cakery</span>
        </a>
      </div>
    </footer>
  );
}